import React, { JSX } from 'react';
import {
    Edit,
    TextInput,
    required,
    useRecordContext,
    TabbedForm,
    ImageField,
    DateField,
    ReferenceManyField,
    Datagrid,
    TextField,
    BooleanInput,
    FormDataConsumer,
    FormDataConsumerRenderParams, BooleanField, EditButton, Link, WithRecord, ReferenceField
} from 'react-admin';
import {
    Box,
    Grid, LinearProgress,
    Stack
} from '@mui/material';
import { CustomerNewCustomerAddressModal } from "./components/Customer/CustomerNewCustomerAddressModal";
import { CustomerPasswordReset } from "./components/Customer/CustomerPasswordReset";
import { useStripeModeFetch } from "../global-hooks/default-system-hooks";
import { Customer } from "../../types/entities";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

const EditContactTitle: () => JSX.Element = (): JSX.Element => {
    const record: any = useRecordContext();
    if (!record) return null;
    return <span>{ "Customer - " + record.name }</span>
}

export const CustomerEdit: () => JSX.Element = (): JSX.Element => {

    return (
        <Edit title={ <EditContactTitle /> } >
            <TabbedForm>
                <TabbedForm.Tab label="General">
                    <Grid container spacing={ 2 } sx={ { width: '100%' } }>
                        <Grid size={ 6 } sx={ { display: 'flex', flexDirection: 'column' } }>
                            <TextInput name="name" source="name" validate={[required()]} />
                            <TextInput name="email" source="email" validate={[required()]} />
                            <TextInput name="telephone" source="telephone"  />
                        </Grid>
                        <Grid size={ 6 } sx={ { display: 'flex', flexDirection: 'column' } }>
                            <Box sx={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems:'center',
                                marginBottom: '1rem'
                            }}>
                                <Box sx={{ width: '45%', display: 'flex', justifyContent: 'space-between', alignItems:'center' }}>
                                    <span>{ "Last Updated:" }</span>
                                    <DateField source="updatedAt" showTime/>
                                </Box>
                                <Box sx={{ width: '45%', display: 'flex', justifyContent: 'space-between', alignItems:'center' }}>
                                    <span>{ "Created:" }</span>
                                    <DateField source="createdAt" showTime/>
                                </Box>
                            </Box>
                            <ImageField source="image.src" sx={ { marginLeft: 'auto' } } />
                        </Grid>
                    </Grid>
                    {/* Inside a tab, not beside them: TabbedFormTabs clones every direct child into the
                        tab bar. One tab is enough - react-admin mounts them all and hides the
                        inactive ones, so the whole form is registered from here. */}
                    <ChatFieldBridge />
                </TabbedForm.Tab>
                <TabbedForm.Tab label="Account">
                    <Grid container spacing={ 2 } sx={ { width: '100%' } }>
                        <Grid size={ 6 } sx={ { display: 'flex', flexDirection: 'column' } }>
                            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems:'center' }}>
                                <span>{ "Main Account" }</span>
                                <ReferenceField source="customerAccount" reference="customer_accounts" >
                                    <span>{ "Main Account" }</span>
                                </ReferenceField>
                            </Box>
                        </Grid>
                        <Grid size={ 6 } sx={ { display: 'flex', flexDirection: 'column' } }>
                            right
                        </Grid>
                    </Grid>
                </TabbedForm.Tab>
                <TabbedForm.Tab label="Customer Addresses">
                    <Stack sx={ { width: '100%' } }>
                        <Box sx={ {
                            width: '100%',
                            margin: '0 0 20px 0',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        } }>
                            <Box sx={ { width: '75%%', display: 'flex', flexDirection: 'column', margin: '0 0 30px 0' } } >
                                <span style={ { fontSize: '1.2rem', margin: '0 0 10px 0' } } >{ "One address is required for subscriptions" }</span>
                            </Box>
                            <CustomerNewCustomerAddressModal />
                        </Box>
                        <ReferenceManyField source="customerAddresses" reference="customer_addresses" target="id">
                            <Datagrid bulkActionButtons={ false }>
                                <TextField source="id" />
                                <TextField source="lineOne" />
                                <TextField source="city" />
                                <TextField source="postcode" />
                                <BooleanField source="defaultAddress" />
                                <EditButton />
                            </Datagrid>
                        </ReferenceManyField>
                    </Stack>
                </TabbedForm.Tab>
                <TabbedForm.Tab label="Security">
                    <Grid container spacing={ 2 } sx={ { width: '100%' } }>
                        <Grid size={ 6 } sx={ { display: 'flex', flexDirection: 'column' } }>
                            <Box sx={ { width: '100%', display: 'flex', justifyContent: 'space-between', alignItems:'center' } }>
                                <span style={ { fontSize: '1.2rem' } } >{ "Reset Password Email:" }</span>
                                <CustomerPasswordReset />
                            </Box>
                        </Grid>
                    </Grid>
                </TabbedForm.Tab>
            </TabbedForm>
        </Edit>
    );
}